import useFetch from '@/composables/useFetch';
import { PaginationResponse } from '@/model/api';
import {
	Document,
	Documentor,
	DocumentPaginationRequest,
	DocumentorPaginationRequest,
	DocumentType
} from '@/model/document';

export async function getDocumentorPagination(query: DocumentorPaginationRequest) {
	const res = await useFetch<PaginationResponse<Documentor>>({
		method: 'GET',
		url: '/document/documentor',
		params: query,
		signalUUID: `GET_DOCUMENTOR_PAGINATION`
	});
	return res.data;
}

export async function getDocumentPagination(query: DocumentPaginationRequest) {
	const res = await useFetch<PaginationResponse<Document>>({
		method: 'GET',
		url: '/document',
		params: query,
		signalUUID: `GET_DOCUMENT_PAGINATION`
	});
	return res.data;
}

export async function getDocumentDetail(documentUUID: string, useSignal = false) {
	const res = await useFetch<Document>({
		method: 'GET',
		url: '/document/' + documentUUID,
		signalUUID: useSignal ? `GET_DOCUMENT_DETAIL` : undefined
	});
	return res.data;
}

export async function favoriteDocument(documentUUID: string, isFavorite: boolean, fileID?: string) {
	return await useFetch({
		method: 'PATCH',
		url: `/document/${documentUUID}/favorite`,
		data: {
			isFavorite,
			fileID
		}
	});
}

export async function createDocument(
	documentType: DocumentType,
	metadataID: string,
	subID: string,
	source: string,
	files: File[]
) {
	const formData = new FormData();
	formData.append('data', JSON.stringify({ documentType, metadataID, subID, source }));
	for (const file of files) {
		formData.append('files', file);
	}
	return await useFetch<{ documentUUID: string }>({
		method: 'POST',
		url: `/document`,
		data: formData,
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
}

export async function updateDocument(documentUUID: string, deleteFileIDs: string[], files: File[]) {
	const formData = new FormData();
	formData.append('data', JSON.stringify({ deleteFileIDs }));
	for (const file of files) {
		formData.append('files', file);
	}
	return await useFetch<{ documentUUID: string }>({
		method: 'PATCH',
		url: `/document/${documentUUID}`,
		data: formData,
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
}

export async function deleteDocument(documentUUID: string, fileID?: string) {
	return await useFetch({
		method: 'DELETE',
		url: `/document/${documentUUID}`,
		data: { fileID }
	});
}
